import styled, { css } from 'styled-components';
import { mq, getSpace, getColor, getGridSpans, backgroundShape } from '../../../stylesheets/tools';
import { fontFamilies } from '../../../stylesheets/settings';

const StyledLoginMask = styled.div`
  padding: ${getSpace('xl')} 0;
  position: relative;
  display: block;

  .loginMask__content {
    ${getGridSpans('width', { s: 11, m: 6 })}
    ${getGridSpans('margin-left', { s: [1, 'spread'], m: [3, 'spread'] })}
  }

  .loginMask__headline {
    margin-bottom: ${getSpace('xs')};
  }

  .loginMask__icon {
    position: absolute;
    top: -31px;
    left: 20px;
    width: 54px;
    height: 54px;
    

    ${mq('m')} {
      top: -38px;
      width: 66px;
      height: 66px;
    }
  }

  .loginMask__buttons {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    order: 1;

    ${mq('m')} {
      align-items: flex-start;
      margin-left: -20px;
      order: 0;
    }

    button {
      text-align: left;
      margin-right: 0;
      margin-top: 10px;

      ${mq('m')} {
        margin-top: 0;
        
       &:nth-child(2) {
         margin-top: 10px;
       }
      }
    }
  }

  .loginMask__current-token {
    text-transform: uppercase;
  }

  .loginMask__token-label {
    margin-right: 10px;
    margin-top: 20px;
    
  }

  .loginMask__token {
    font-family: ${fontFamilies.default};
    font-weight: 400;
    text-transform: uppercase;
    font-size: 2rem;
    letter-spacing: 0.75rem;
    line-height: 1;
    margin-top: 10px;
  }

  .loginMask__form {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;

    ${mq('m')} {
      flex-direction: row;
    }
  }

  .loginMask__form-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: ${getSpace('l')} 0 ${getSpace('xxs')};
    ${getGridSpans('width', { s: 12, m: [10, 'spread'] })}
    ${getGridSpans('margin-left', { s: 0, m: [2, 'normal'] })}

    ${mq('m')} {
      flex-direction: row;
    }
  }

  .loginMask__hint {
    ${getGridSpans('width', { s: 12, m: [7, 'spread', 10] })}
    ${getGridSpans('padding-left', { s: [1, 'spread'], m: [1, 'full', 10] })}
  }

  .loginMask__input,
  .loginMask__current-token {
    ${getGridSpans('width', { s: 12, m: [7, 'spread', 10] })}
    padding: ${getSpace('l')} ${getSpace('m')};
    ${getGridSpans('padding-left', { m: [1, 'spread', 10] })}

    ${props =>
      props.theme.siteTheme &&
      css`
        ${backgroundShape(props.theme.siteTheme.tertiary)}
      `};
  }

  .loginMask__current-token {
    margin: 0;
  }

  .loginMask__current-token p {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 10px;

    ${mq('m')} {
      justify-content: flex-start;
      align-items: baseline;
    }
  }

  .loginMask__input {
    padding-bottom: ${getSpace('xs')};
  }

  ${props =>
    props.insideNavigation &&
    css`
      width: 100%;
      max-width: 500px;
      color: ${getColor('white')};
      padding: ${getSpace('l')} 0;

      .loginMask__buttons {
        align-items: flex-end;
        margin-left: 0;
        order: 0;

        button {
          color: ${getColor('white')};
        }
      }
      .loginMask__content {
        width: 100%;
        margin: 0;
      }
      .loginMask__form-wrapper {
        margin-left: 0;
        margin-right: 0;
        width: 100%;

        flex-direction: column;
      }

      .loginMask__input,
      .loginMask__current-token {
        width: 100%;
        padding: ${getSpace('m')} ${getSpace('s')};
      }

      .loginMask__hint {
        width: 100%;
        padding: 0;
      }

      .loginMask__input {
        padding: 0;
        flex-grow: 2;
        background: transparent;

        .tokenInput__instructions {
          margin-left: 0;
        }
      }

      .loginMask__icon {
        top: -31px;
        left: 20px;
        width: 54px;
        height: 54px;
      }

      .loginMask__current-token p {
        align-items: center;
        justify-content: center;
      }
    `}

  ${props =>
    props.isTeaserCard &&
    css`
      width: 100%;
      height: calc(100% - 38px);
      color: ${getColor('black')};
      padding: ${getSpace('s')} 0;
      margin: 0;
      padding: ${getSpace('s')} 0;
      display: flex;
      flex-direction: column;
      margin-top: auto;

      &:before {
        content: '';
        width: 100%;
        height: 100%;
        clip-path: polygon(25px 0, 100% 0, 100% 100%, 0 100%, 0 20px);
        background: ${getColor('teaserPink')};
        position: absolute;
        top: 0;
        left: 0;
      }

      svg.loginMask__icon {
        fill: ${props.isTeaserCard && props.isDarkTheme ? getColor('white') : getColor('black')};
      }

      .loginMask__content {
        position: relative;
        width: 100%;
        padding: 3rem 3rem 1rem 3rem;
        margin: auto 0 1rem 0;
      }

      .loginMask__form-wrapper {
        flex-direction: column;
        margin: auto;
        height: 100%;
        padding: 0rem 3rem;

        ${mq('m')} {
          padding: 0rem 1rem;
        }
      }

      .loginMask__current-token {
        background: none;
        width: 100%;
        padding: 0;
        margin: 0 auto 0 auto;

        p {
          display: flex;
          flex-direction: column;
        }
      }

      .loginMask__buttons {
        width: 100%;
        margin: 0 auto auto auto;
        padding-top: ${getSpace('m')};
      }

      .loginMask__form {
        margin: auto;
      }

      .loginMask__input {
        background: none;
        margin: 0;
        padding: 0;
      }

      input#tokenInput::after {
        background: none;
      }
    `}
`;

export default StyledLoginMask;
